import { TownsquareProjectUpdateAri } from '@atlassian/ari';
import { validate as uuidValidate } from 'uuid';

/* Depending on the state of the gate "townsquare_enable_update_dtos" ProjectUpdates will return a different id value.
 *
 * gate = false: Internal Relay ID (Base64 encoded)
 * 		projectUpdate.id = UHJvamVjdFVwZGF0ZTo5OTI3MzAw
 * gate = true: TownsquareProjectUpdate ARI
 * 		projectUpdate.id = ari:cloud:townsquare:a436116f-02ce-4520-8fbb-7301462a1674:project-update/cf4708da-0eb3-4cca-b619-63872386c10d
 *
 * This util helps us extract the UUID from the ARI if the ARI exists - otherwise we assume we're still dealing with the Internal Relay ID.
 */
export const maybeGetUuidFromResponseUpdateId = (responseUpdateId: string): string => {
	try {
		const projectUpdateAri = TownsquareProjectUpdateAri.parse(responseUpdateId);
		return projectUpdateAri.projectUpdateUuid;
	} catch {
		return responseUpdateId;
	}
};

/* This util helps us handle both Relay ID and UUIDs for project update IDs from the URL. It's essentially the opposite of the util above.
 * If we can parse a UUID, we'll assume we're using the the new format. Otherwise we'll fallback to the OG relay Base64 id.
 */
export const maybeGetProjectUpdateAriFromUrlUpdateId = (urlUpdateId: string, workspaceCloudId?: string): string => {
	if (uuidValidate(urlUpdateId) && workspaceCloudId) {
		return TownsquareProjectUpdateAri.create({
			siteId: workspaceCloudId,
			projectUpdateUuid: urlUpdateId,
		}).toString();
	}
	return urlUpdateId;
};
